"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlProgramSpecification = void 0;
const rc_js_util_1 = require("rc-js-util");
const gl_shader_1 = require("./gl-shader");
/**
 * @public
 * {@inheritDoc IGlProgramSpec}
 */
class GlProgramSpecification {
    constructor(vertexShader, fragmentShader, requiredExtensions = [], optionalExtensions = [], outAttributes = null) {
        this.vertexShader = vertexShader;
        this.fragmentShader = fragmentShader;
        this.requiredExtensions = requiredExtensions;
        this.optionalExtensions = optionalExtensions;
        this.outAttributes = outAttributes;
        DEBUG_MODE && rc_js_util_1._Debug.runBlock(() => {
            const vlv = this.vertexShader.requiredLanguageVersion;
            const flv = this.fragmentShader.requiredLanguageVersion;
            if (vlv != null && flv != null) {
                rc_js_util_1._Debug.assert(vlv === flv, "vertex and fragment shader language versions must be the same");
            }
        });
        if (this.vertexShader.requiredLanguageVersion != null) {
            this.shaderLanguageVersion = this.vertexShader.requiredLanguageVersion;
        }
    }
    static mergeProgramSpecifications(specs) {
        const vertexVersion = GlProgramSpecification.getHighestShaderVersion(specs, "vertexShader");
        const fragmentVersion = GlProgramSpecification.getHighestShaderVersion(specs, "fragmentShader");
        const version = rc_js_util_1._Math.max(vertexVersion, fragmentVersion);
        const combinedVertexShader = GlProgramSpecification.combineShadersFinal(specs, "vertexShader", version, GlProgramSpecification.vertexShaderCompat);
        const combinedFragmentShader = GlProgramSpecification.combineShadersFinal(specs, "fragmentShader", version, GlProgramSpecification.fragmentShaderCompat);
        const requiredExts = rc_js_util_1._Array.collect(specs, new Set(), (extensions, specification) => {
            rc_js_util_1._Array.forEach(specification.requiredExtensions, (extension) => extensions.add(extension));
        });
        const optionalExts = rc_js_util_1._Array.collect(specs, new Set(), (extensions, specification) => {
            rc_js_util_1._Array.forEach(specification.optionalExtensions, (extension) => extensions.add(extension));
        });
        return new GlProgramSpecification(combinedVertexShader, combinedFragmentShader, rc_js_util_1._Set.valuesToArray(requiredExts), rc_js_util_1._Set.valuesToArray(optionalExts), rc_js_util_1._Array.flatMap(specs, (spec) => spec.outAttributes));
    }
    static getHighestShaderVersion(specs, key) {
        let version = -1;
        for (let i = 0, iEnd = specs.length; i < iEnd; ++i) {
            const shader = specs[i][key];
            if (shader.requiredLanguageVersion != null && shader.requiredLanguageVersion > version) {
                version = shader.requiredLanguageVersion;
            }
        }
        return version;
    }
    static combineShadersFinal(specs, key, version, compatPrefix) {
        const preLines = 3;
        const vertexParts = new Array(specs.length + preLines);
        let j = preLines;
        for (let i = 0, iEnd = specs.length; i < iEnd; ++i) {
            const shader = specs[i][key];
            vertexParts[j++] = shader.source;
            if (shader.requiredLanguageVersion != null && shader.requiredLanguageVersion > version) {
                version = shader.requiredLanguageVersion;
            }
        }
        vertexParts[0] = version === -1 ? "" : `#version ${version} es`;
        vertexParts[2] = compatPrefix;
        return new gl_shader_1.GlShader(vertexParts.join("\n"), version === -1 ? undefined : version);
    }
}
exports.GlProgramSpecification = GlProgramSpecification;
// @formatter:off
// when updating make sure to update the language injection prefix
// language=GLSL
GlProgramSpecification.vertexShaderCompat = `
#if __VERSION__ >=300 && __VERSION__ < 400
#define ATTRIBUTE in
#define VARYING out
#else
#define ATTRIBUTE attribute
#define VARYING varying
#endif`;
// @formatter:on
// @formatter:off
// when updating make sure to update the language injection prefix
// language=GLSL
GlProgramSpecification.fragmentShaderCompat = `
#if __VERSION__ >=300 && __VERSION__ < 400
out highp vec4 fragColor;
#endif

#if __VERSION__ >=300 && __VERSION__ < 400
#define VARYING in
#define TEXTURE2D texture
#else
#define VARYING varying
#define TEXTURE2D texture2D
#endif

void setFragmentColor(in lowp vec4 color)
{
    #if __VERSION__ >=300 && __VERSION__ < 400
    fragColor = color;
    #else
    gl_FragColor = color;
    #endif
}`;
//# sourceMappingURL=gl-program-specification.js.map